'use client';

import { ChevronDown } from 'lucide-react';
import * as React from 'react';

export interface LabeledSelectProps {
	/** Etichetta mostrata a sinistra del select. */
	label: React.ReactNode;
	/** Valore selezionato corrente. */
	value: string;
	/** Chiamata alla selezione di una nuova opzione. */
	onChange: (value: string) => void;
	/** Se true, disabilita il select. */
	disabled?: boolean;
	/** Elementi `<option>` del select. */
	children: React.ReactNode;
}

/** Etichetta inline + select con chevron, per selettori di scope in stile toolbar. */
const LabeledSelect = ({ label, value, onChange, disabled, children }: LabeledSelectProps) => {
	const id = React.useId();
	return (
		<div className="flex items-center gap-2">
			<label htmlFor={id} className="text-[13px] font-semibold text-text-muted">
				{label}
			</label>
			<div className="relative">
				<select
					id={id}
					value={value}
					onChange={(e) => onChange(e.target.value)}
					disabled={disabled}
					className="appearance-none rounded-lg border border-border bg-card py-2 pl-3 pr-9 text-xs font-semibold text-text outline-none focus:border-accent disabled:opacity-50"
				>
					{children}
				</select>
				<ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-text-muted" />
			</div>
		</div>
	);
};
LabeledSelect.displayName = 'LabeledSelect';

export { LabeledSelect };
